module.exports = __webpack_public_path__ + "static/bodas-8244197f34004395c568ba8976c6452a.jpg";